import { render, staticRenderFns } from "./organizationList.vue?vue&type=template&id=4dade134"
import script from "./organizationList.vue?vue&type=script&lang=js"
export * from "./organizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports